import type { ApolloClient } from "@apollo/client";
import type { Permission } from "@observe-tech/mfe-shell-api";
import { GET_MY_PERMISSIONS } from "../graphql/permissions.queries";

export interface PermissionsApi {
  has(perm: string): boolean;
  list(): string[];
  raw(): Permission[];
  onChange(cb: () => void): () => void;
  refresh(): Promise<void>;
}

export function createPermissionsApi(
  client: ApolloClient<unknown>,
): PermissionsApi {
  let perms: Permission[] = [];
  const subs = new Set<() => void>();
  return {
    has: (p) => perms.some((entry) => entry.active && entry.name === p),
    list: () => perms.filter((p) => p.active).map((p) => p.name),
    raw: () => [...perms],
    onChange: (cb) => {
      subs.add(cb);
      return () => {
        subs.delete(cb);
      };
    },
    refresh: async () => {
      const r = await client.query<{ getPermissions: Permission[] }>({
        query: GET_MY_PERMISSIONS,
        fetchPolicy: "network-only",
      });
      perms = r.data.getPermissions ?? [];
      for (const cb of subs) cb();
    },
  };
}
